export default __webpack_public_path__ + "static/media/homeBg.3d596142.png";